<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t('ALTERARDATASOLICITACAO.ALTERAR')}}</p>
        </header>
        <section class="modal-card-body">
            <b-field>
                <b-datetimepicker rounded
                                  :placeholder="$t('ALTERARDATASOLICITACAO.DATAHORA')"
                                  icon="calendar-today"
                                  v-model="novaDataDeSolicitacao"
                                  inline
                                  horizontal-time-picker>
                </b-datetimepicker>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                      @click="alterarDataDeSolicitacao">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close')">{{$t('ALTERARDATASOLICITACAO.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            selecionado: Array
        },
        data() {
            return {
                novaDataDeSolicitacao: new Date()
            }
        },
        methods: {
            alterarDataDeSolicitacao() {
                this.selecionado.forEach(x => {
                    x.dataDeSolicitacao = this.novaDataDeSolicitacao
                })
                this.$emit('close')
            }
        }
    }
</script>